import FieldConfig from "../../proto/field-config"
import FieldDropdown from "../dropdown/dropdown"
import {GROUP_SELECT} from "../../../gd/const/fields/field2-groups"
import FieldRadioGroup_FormElementView from "./render/form/form-element-view"

export default class FieldRadioGroup extends FieldDropdown {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel              = "Radio group"
        this.typeGroup              = GROUP_SELECT
        this.typeDescription        = "Option select (radio group) field"

        this.renderComponents.formElementView = FieldRadioGroup_FormElementView
    }
}
